import React from 'react';
import { PropsWithTestId } from '../../../../../../../types';
import { FileDownloadModuleType } from '../index';
import { DownloadIcon } from '../DownloadIcon';
import { Heading, Line, Paragraph } from '../../../components';
import { Button } from '../../../../Button';
import styles from './ThumbStyleNone.module.scss';
import gtmService from '../../../../../../../utils/gtm';
import { CTAClickType } from '../../../../../../../utils/gtm/types';

export type ThumbStylesNoneProps = Pick<
  FileDownloadModuleType,
  'ctatext' | 'title' | 'titleSize' | 'text' | 'file'
>;

export default function ThumbStylesNone(
  props: PropsWithTestId<ThumbStylesNoneProps>,
) {
  const { ctatext, title, titleSize, text, file, testId } = props;

  const onClickHandler = () => {
    gtmService.ga4VideoPlay({
      cta_title: title,
      filename: file,
      description: ctatext,
    } as unknown as CTAClickType);
  };

  return (
    <div data-testid={testId} className="row middle-md">
      <div className="col-xs-12 col-sm-12 col-lg-12">
        {title && (
          <>
            <div className={styles.titleWrapper}>
              <DownloadIcon className={styles.downloadIcon} />
              <Heading titleSize={titleSize} className={styles.heading}>
                {title}
              </Heading>
            </div>
            <Line className={styles.line} />
          </>
        )}
        <Button
          data-testid="hub-module-download-link"
          to={`/uploads/${file.filename}`}
          onClick={onClickHandler}
        >
          {ctatext || 'Download'}
        </Button>
        {text && <Paragraph text={text} className={styles.paragraph} />}
      </div>
    </div>
  );
}

ThumbStylesNone.defaultProps = {
  testId: 'hub-module-thumb-style-none',
};
